__turbopack_context__.v({
  "body": "UserInfoModal-module-scss-module__kLKmAa__body",
  "content": "UserInfoModal-module-scss-module__kLKmAa__content",
  "header": "UserInfoModal-module-scss-module__kLKmAa__header",
  "input": "UserInfoModal-module-scss-module__kLKmAa__input",
  "overlay": "UserInfoModal-module-scss-module__kLKmAa__overlay",
});
